(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", init);
  if (document.readyState === "complete" || document.readyState === "interactive") init();

  function init() {
    var root = document.querySelector("[data-hat-builder]");
    if (!root || root.dataset.hbInitialized) return;
    root.dataset.hbInitialized = "true";

    var dataEl = root.querySelector("[data-hat-builder-data]");
    var data = { styles: [], designs: [] };
    try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error("Hat Builder: could not parse config", e); }

    var state = {
      step: 1,
      maxStepReached: 1,
      styleBlockId: null,
      variantId: null,
      colorName: null,
      mode: "gallery",
      galleryDesign: null,
      prefilledFromBrowse: false,
      patchMaterial: null,
      patchColorId: null,
      patchColorName: null,
      patchShapeId: null,
      patchShapeName: null,
      uploadedFile: null,
      artworkAcknowledged: false,
      notes: "",
      placement: "Centered",
      personalization: "",
      quantity: 1
    };

    function q(sel) { return root.querySelector(sel); }
    function qa(sel) { return root.querySelectorAll(sel); }

    function el(tag, attrs, children) {
      var node = document.createElement(tag);
      if (attrs) {
        Object.keys(attrs).forEach(function (k) {
          if (k === "text") node.textContent = attrs[k];
          else node.setAttribute(k, attrs[k]);
        });
      }
      (children || []).forEach(function (c) { node.appendChild(c); });
      return node;
    }

    function announce(msg) { q("#hb-status-line").textContent = msg; }
    function focusStepHeading(n) { var p = q("#hb-step-" + n); if (p) p.focus(); }

    function updateStepper() {
      qa("#hb-stepper-list li").forEach(function (li) {
        var n = parseInt(li.getAttribute("data-step"), 10);
        if (n < state.step) li.setAttribute("data-state", "done");
        else if (n === state.step) li.setAttribute("data-state", "current");
        else li.setAttribute("data-state", "upcoming");
        var tab = li.querySelector(".hb-step-tab");
        if (tab) tab.disabled = n > state.maxStepReached;
      });
    }

    function goToStep(n) {
      for (var i = 1; i <= 4; i++) {
        var panel = q("#hb-step-" + i);
        if (panel) panel.hidden = (i !== n);
      }
      state.step = n;
      state.maxStepReached = Math.max(state.maxStepReached, n);
      updateStepper();
      focusStepHeading(n);
      var labels = { 1: "Choose your style.", 2: "Choose your color.", 3: "Customize your hat.", 4: "Review and add to cart." };
      announce("Step " + n + " of 4: " + labels[n]);
      if (n === 3) renderGalleryGrid();
      if (n === 4) buildSummary();
      updateLiveSummary();
    }

    qa(".hb-step-tab").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var n = parseInt(tab.getAttribute("data-step-btn"), 10);
        if (n <= state.maxStepReached) goToStep(n);
      });
    });

    root.addEventListener("contextmenu", function (e) {
      if (e.target.closest(".hb-card-swatch")) e.preventDefault();
    });

    // ---- Step 1: styles ----
    var styleGrid = q("#hb-style-grid");
    data.styles.forEach(function (s) {
      var input = el("input", { class: "hb-card-input", type: "radio", name: "hb-style", id: "hb-style-" + s.blockId, value: s.blockId });
      var kids = [
        el("span", { class: "hb-card-swatch", style: "background-image:url(" + s.image + ");", "aria-hidden": "true" }),
        el("span", { class: "hb-card-title", text: s.name })
      ];
      if (s.note) kids.push(el("span", { class: "hb-card-note", text: s.note }));
      styleGrid.appendChild(input);
      styleGrid.appendChild(el("label", { class: "hb-card-label", for: "hb-style-" + s.blockId }, kids));
    });
    // Clicking a style card (mouse/touch only, never keyboard arrow-navigation)
    // selects it and advances straight to Step 2, since a real click is an
    // explicit choice. Keyboard users still get the Continue button below,
    // since arrow-key browsing between radio options must never auto-navigate.
    styleGrid.addEventListener("click", function (e) {
      var label = e.target.closest("label.hb-card-label");
      if (!label) return;
      var input = q("#" + label.getAttribute("for"));
      if (!input || input.disabled) return;
      state.styleBlockId = input.value;
      q("#hb-step1-next").disabled = false;
      renderColors();
      q("#hb-step2-next").disabled = true;
      state.variantId = null;
      state.colorName = null;
      goToStep(2);
    });

    // ---- Step 2: colors ----
    var colorGrid = q("#hb-color-grid");
    function renderColors() {
      colorGrid.innerHTML = "";
      var style = data.styles.find(function (s) { return String(s.blockId) === String(state.styleBlockId); });
      q("#hb-color-selected-style").textContent = style ? style.name : "\u2014";
      (style ? style.colors : []).forEach(function (c) {
        var input = el("input", { class: "hb-card-input", type: "radio", name: "hb-color", id: "hb-color-" + c.id, value: c.id });
        if (!c.available) input.setAttribute("disabled", "disabled");
        var kids = [
          el("span", { class: "hb-card-swatch", style: "background-image:url(" + c.image + ");", "aria-hidden": "true" }),
          el("span", { class: "hb-card-title", text: c.name })
        ];
        if (!c.available) kids.push(el("span", { class: "hb-card-note", text: "Out of stock" }));
        colorGrid.appendChild(input);
        colorGrid.appendChild(el("label", { class: "hb-card-label", for: "hb-color-" + c.id }, kids));
      });
    }
    // Same click-to-select-and-advance pattern as Step 1, for mouse/touch only.
    colorGrid.addEventListener("click", function (e) {
      var label = e.target.closest("label.hb-card-label");
      if (!label) return;
      var input = q("#" + label.getAttribute("for"));
      if (!input || input.disabled) return;
      state.variantId = input.value;
      var style = data.styles.find(function (s) { return String(s.blockId) === String(state.styleBlockId); });
      var color = style ? style.colors.find(function (c) { return String(c.id) === String(input.value); }) : null;
      state.colorName = color ? color.name : null;
      q("#hb-step2-next").disabled = false;
      goToStep(3);
    });

    // ---- Step 3: gallery ----
    var galleryGrid = q("#hb-gallery-grid");
    var galleryActiveCategory = { value: null };
    function renderGalleryGrid() {
      galleryGrid.innerHTML = "";
      data.designs.forEach(function (d) {
        var wrap = el("div", { class: "hb-swatch-item" });
        var input = el("input", { class: "hb-card-input", type: "radio", name: "hb-gallery", id: "hb-gallery-" + d.id, value: d.id, "data-search": d.name.toLowerCase(), "data-categories": (d.categories || []).join("|").toLowerCase() });
        if (String(state.galleryDesign) === String(d.id)) input.setAttribute("checked", "checked");
        var label = el("label", { class: "hb-card-label", for: "hb-gallery-" + d.id }, [
          el("span", { class: "hb-card-swatch", style: "background-image:url(" + d.image + ");", "aria-hidden": "true" }),
          el("span", { class: "hb-card-title", text: d.name })
        ]);
        var viewBtn = el("button", { type: "button", class: "hb-view-btn", text: "View larger" });
        viewBtn.addEventListener("click", function () { openLightbox(d.image, d.name, viewBtn); });
        wrap.appendChild(input);
        wrap.appendChild(label);
        wrap.appendChild(viewBtn);
        galleryGrid.appendChild(wrap);
      });
      buildCategoryPills(q("#hb-gallery-categories"), galleryGrid, q("#hb-gallery-search"), "#hb-gallery-count", galleryActiveCategory);
      filterCards(q("#hb-gallery-search"), galleryGrid, "#hb-gallery-count", galleryActiveCategory.value);
      updateGallerySelectionView();
    }
    renderGalleryGrid();
    // Selecting a premade design no longer auto-advances, since Color and
    // Placement (shared with "Design your own") still need to be chosen too.
    galleryGrid.addEventListener("click", function (e) {
      var label = e.target.closest("label.hb-card-label");
      if (!label) return;
      var input = q("#" + label.getAttribute("for"));
      if (!input || input.disabled) return;
      state.galleryDesign = input.value;
      updateStep3NextState();
      updateLiveSummary();
      updateGallerySelectionView();
    });

    // Once a design is picked, collapse the whole search/pills/grid picker
    // down to a compact "Design selected" card instead of showing it again.
    function updateGallerySelectionView() {
      var picker = q("#hb-gallery-picker");
      var selected = q("#hb-gallery-selected");
      if (!picker || !selected) return;
      var d = data.designs.find(function (g) { return String(g.id) === String(state.galleryDesign); });
      if (d) {
        picker.hidden = true;
        selected.hidden = false;
        q("#hb-gallery-selected-swatch").style.backgroundImage = "url(" + d.image + ")";
        q("#hb-gallery-selected-name").textContent = d.name;
        var personalizeGroup = q("#hb-gallery-personalize-group");
        if (d.customizable) {
          personalizeGroup.hidden = false;
          var promptText = d.personalizationPrompt || "Add a name or personalization (optional)";
          q("#hb-gallery-personalize-label").textContent = promptText;
          q("#hb-gallery-personalize").placeholder = "e.g. " + promptText.toLowerCase();
        } else {
          personalizeGroup.hidden = true;
          q("#hb-gallery-personalize").value = "";
          state.personalization = "";
        }
      } else {
        picker.hidden = false;
        selected.hidden = true;
      }
    }
    q("#hb-gallery-change-btn").addEventListener("click", function () {
      q("#hb-gallery-picker").hidden = false;
      q("#hb-gallery-selected").hidden = true;
    });
    q("#hb-gallery-personalize").addEventListener("input", function (e) {
      state.personalization = e.target.value;
    });

    function getAllCategories() {
      var set = {};
      data.designs.forEach(function (d) {
        (d.categories || []).forEach(function (c) { if (c) set[c] = true; });
      });
      return Object.keys(set).sort();
    }

    function buildCategoryPills(container, grid, searchInput, countSelector, activeRef) {
      if (!container) return;
      var categories = getAllCategories();
      container.innerHTML = "";
      if (!categories.length) { container.hidden = true; return; }
      container.hidden = false;
      function makePill(label, value) {
        var isActive = activeRef.value === value;
        var btn = el("button", { type: "button", class: "hb-pill", "aria-pressed": isActive ? "true" : "false", text: label });
        btn.addEventListener("click", function () {
          activeRef.value = (activeRef.value === value) ? null : value;
          buildCategoryPills(container, grid, searchInput, countSelector, activeRef);
          filterCards(searchInput, grid, countSelector, activeRef.value);
        });
        return btn;
      }
      container.appendChild(makePill("All", null));
      categories.forEach(function (c) { container.appendChild(makePill(c, c.toLowerCase())); });
    }

    function filterCards(searchInput, grid, countSelector, activeCategory) {
      var term = (searchInput.value || "").trim().toLowerCase();
      var inputs = grid.querySelectorAll("input.hb-card-input, button.hb-card-label");
      var shown = 0;
      inputs.forEach(function (node) {
        var name = (node.getAttribute("data-search") || node.textContent || "").toLowerCase();
        var cats = (node.getAttribute("data-categories") || "").split("|").filter(Boolean);
        var matchText = !term || name.indexOf(term) !== -1;
        var matchCat = !activeCategory || cats.indexOf(activeCategory) !== -1;
        var match = matchText && matchCat;
        var wrapEl = node.closest(".hb-swatch-item");
        if (wrapEl) {
          wrapEl.hidden = !match;
        } else if (node.tagName === "INPUT") {
          node.hidden = !match;
          var label = grid.querySelector('label[for="' + node.id + '"]');
          if (label) label.hidden = !match;
        } else {
          node.hidden = !match;
        }
        if (match) shown++;
      });
      var countEl = q(countSelector);
      if (countEl) countEl.textContent = (term || activeCategory) ? ("Showing " + shown + " of " + inputs.length + " designs.") : "";
    }
    q("#hb-gallery-search").addEventListener("input", function () {
      filterCards(this, galleryGrid, "#hb-gallery-count", galleryActiveCategory.value);
    });

    // ---- Browse entry ----
    var browseGrid = q("#hb-browse-grid");
    var browseActiveCategory = { value: null };
    data.designs.forEach(function (d) {
      var wrap = el("div", { class: "hb-swatch-item" });
      var selectBtn = el("button", { type: "button", class: "hb-card-label", style: "width:100%; text-align:left;",
        "data-search": d.name.toLowerCase(),
        "data-categories": (d.categories || []).join("|").toLowerCase(),
        "aria-label": "Select " + d.name + " and continue to choose your hat style" }, [
        el("span", { class: "hb-card-swatch", style: "background-image:url(" + d.image + ");", "aria-hidden": "true" }),
        el("span", { class: "hb-card-title", text: d.name })
      ]);
      selectBtn.addEventListener("click", function () {
        state.galleryDesign = d.id;
        state.mode = "gallery";
        state.prefilledFromBrowse = true;
        enterBuilder(1);
      });
      var viewBtn = el("button", { type: "button", class: "hb-view-btn", text: "View larger" });
      viewBtn.addEventListener("click", function () { openLightbox(d.image, d.name, viewBtn); });
      wrap.appendChild(selectBtn);
      wrap.appendChild(viewBtn);
      browseGrid.appendChild(wrap);
    });
    buildCategoryPills(q("#hb-browse-categories"), browseGrid, q("#hb-browse-search"), "#hb-browse-count", browseActiveCategory);
    filterCards(q("#hb-browse-search"), browseGrid, "#hb-browse-count", browseActiveCategory.value);
    q("#hb-browse-search").addEventListener("input", function () {
      filterCards(this, browseGrid, "#hb-browse-count", browseActiveCategory.value);
    });

    q("#hb-show-browse-btn").addEventListener("click", function () {
      q("#hb-browse-gallery").hidden = false;
      q("#hb-browse-gallery-h").focus();
    });
    q("#hb-skip-browse-btn").addEventListener("click", function () {
      state.prefilledFromBrowse = false;
      enterBuilder(1);
    });

    function enterBuilder(startStep) {
      q("#hb-screen-browse").hidden = true;
      q("#hb-builder-wrap").hidden = false;
      var note = q("#hb-prefill-note");
      if (state.prefilledFromBrowse) {
        var d = data.designs.find(function (g) { return String(g.id) === String(state.galleryDesign); });
        note.textContent = "You picked \u201c" + (d ? d.name : "a design") + "\u201d while browsing \u2014 just choose your style and color, and it'll be waiting for you in Customize.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
      goToStep(startStep);
    }

    // ---- Delegated change handling for all radio groups ----
    root.addEventListener("change", function (e) {
      if (e.target.name === "hb-style") {
        state.styleBlockId = e.target.value;
        q("#hb-step1-next").disabled = false;
      } else if (e.target.name === "hb-color") {
        state.variantId = e.target.value;
        var style = data.styles.find(function (s) { return String(s.blockId) === String(state.styleBlockId); });
        var color = style ? style.colors.find(function (c) { return String(c.id) === String(e.target.value); }) : null;
        state.colorName = color ? color.name : null;
        q("#hb-step2-next").disabled = false;
      } else if (e.target.name === "hb-gallery") {
        state.galleryDesign = e.target.value;
        updateStep3NextState();
        updateGallerySelectionView();
      } else if (e.target.name === "hb-patchcolor") {
        state.patchColorId = e.target.value;
        var pc = (data.patchColors || []).find(function (c) { return String(c.id) === String(e.target.value); });
        state.patchColorName = pc ? pc.name : null;
        updateStep3NextState();
      } else if (e.target.name === "hb-patchshape") {
        state.patchShapeId = e.target.value;
        var ps = (data.patchShapes || []).find(function (s) { return String(s.id) === String(e.target.value); });
        state.patchShapeName = ps ? ps.name : null;
      } else if (e.target.name === "hb-placement") {
        state.placement = e.target.value;
      } else if (e.target.name === "hb-mode") {
        state.mode = e.target.value;
        q("#hb-panel-gallery").hidden = state.mode !== "gallery";
        q("#hb-panel-own").hidden = state.mode !== "own";
        announce(state.mode === "gallery" ? "Showing premade designs." : "Showing the design-your-own tool.");
        updateStep3NextState();
      }
      updateLiveSummary();
    });

    // ---- Navigation ----
    q("#hb-step1-next").addEventListener("click", function () {
      renderColors();
      q("#hb-step2-next").disabled = true;
      state.variantId = null;
      state.colorName = null;
      goToStep(2);
    });
    q("#hb-step2-back").addEventListener("click", function () { goToStep(1); });
    q("#hb-step2-next").addEventListener("click", function () { goToStep(3); });
    q("#hb-step3-back").addEventListener("click", function () { goToStep(2); });
    q("#hb-step3-next").addEventListener("click", function () { goToStep(4); });
    q("#hb-step4-back").addEventListener("click", function () { goToStep(3); });
    qa(".hb-edit-link").forEach(function (btn) {
      btn.addEventListener("click", function () { goToStep(parseInt(btn.getAttribute("data-goto"), 10)); });
    });

    function buildSummary() {
      var style = data.styles.find(function (s) { return String(s.blockId) === String(state.styleBlockId); });
      q("#hb-summary-style").textContent = style ? style.name : "\u2014";
      q("#hb-summary-color").textContent = state.colorName || "\u2014";
      var customText;
      if (state.mode === "gallery") {
        var d = data.designs.find(function (g) { return String(g.id) === String(state.galleryDesign); });
        customText = d ? ("Premade design \u2014 " + d.name) : "No design selected yet";
        if (state.personalization) customText += " (personalized: \u201c" + state.personalization + "\u201d)";
      } else {
        var parts = [];
        if (state.patchMaterial) parts.push(state.patchMaterial);
        if (state.patchColorName) parts.push(state.patchColorName);
        if (state.patchShapeName) parts.push(state.patchShapeName);
        customText = "Custom patch" + (parts.length ? " \u2014 " + parts.join(", ") : "");
        customText += " (" + state.placement + " placement)";
        customText += state.uploadedFile ? ", artwork uploaded" : ", no artwork uploaded yet";
      }
      q("#hb-summary-custom").textContent = customText;
    }

    // ---- Live "your hat so far" summary, shown across steps 2-4 ----
    function updateLiveSummary() {
      var container = q("#hb-live-summary");
      if (!container) return;
      var chips = [];

      var style = data.styles.find(function (s) { return String(s.blockId) === String(state.styleBlockId); });
      if (style) chips.push({ label: "Style", value: style.name, image: null });

      if (state.colorName && style) {
        var colorObj = style.colors.find(function (c) { return String(c.id) === String(state.variantId); });
        chips.push({ label: "Color", value: state.colorName, image: colorObj ? colorObj.image : null });
      }

      if (state.mode === "gallery" && state.galleryDesign) {
        var d = data.designs.find(function (g) { return String(g.id) === String(state.galleryDesign); });
        if (d) chips.push({ label: "Design", value: d.name, image: d.image });
      } else if (state.mode === "own") {
        var parts = [];
        if (state.patchMaterial) parts.push(state.patchMaterial);
        if (state.patchShapeName) parts.push(state.patchShapeName);
        if (parts.length || state.uploadedFile) {
          chips.push({ label: "Design", value: "Custom" + (parts.length ? " \u2014 " + parts.join(", ") : ""), image: null });
        }
      }

      if (state.patchColorName) {
        var pc = (data.patchColors || []).find(function (c) { return String(c.id) === String(state.patchColorId); });
        chips.push({ label: "Patch Color", value: state.patchColorName, image: pc ? pc.image : null });
      }

      container.innerHTML = "";
      if (!chips.length) { container.hidden = true; return; }
      container.hidden = false;
      chips.forEach(function (chip) {
        var kids = [];
        if (chip.image) kids.push(el("span", { class: "hb-live-chip-swatch", style: "background-image:url(" + chip.image + ");", "aria-hidden": "true" }));
        kids.push(el("span", { class: "hb-live-chip-text" }, [
          el("span", { class: "hb-live-chip-label", text: chip.label }),
          el("span", { class: "hb-live-chip-value", text: chip.value })
        ]));
        container.appendChild(el("div", { class: "hb-live-chip" }, kids));
      });
    }

    // ---- Patch material dropdown ----
    var materialSelect = q("#hb-patch-material");
    if (materialSelect) {
      var noneOpt = el("option", { value: "" }, []);
      noneOpt.textContent = "Select a material\u2026";
      materialSelect.appendChild(noneOpt);
      (data.materials || []).forEach(function (m) {
        if (!m) return;
        var opt = el("option", { value: m }, []);
        opt.textContent = m;
        materialSelect.appendChild(opt);
      });
      if (!(data.materials || []).length) {
        var matGroup = materialSelect.closest(".hb-field-group");
        if (matGroup) matGroup.hidden = true;
      }
      materialSelect.addEventListener("change", function () {
        state.patchMaterial = materialSelect.value || null;
        filterPatchColorsByMaterial(materialSelect.value);
        updateLiveSummary();
      });
    }

    // ---- Patch color & shape swatch grids (with click-to-view) ----
    function buildSwatchGrid(container, items, groupName, extraAttrs) {
      if (!container) return;
      container.innerHTML = "";
      items.forEach(function (item) {
        var wrap = el("div", { class: "hb-swatch-item" });
        var attrs = { class: "hb-card-input", type: "radio", name: groupName, id: groupName + "-" + item.id, value: item.id };
        if (extraAttrs) {
          var extra = extraAttrs(item);
          Object.keys(extra).forEach(function (k) { attrs[k] = extra[k]; });
        }
        var input = el("input", attrs);
        var label = el("label", { class: "hb-card-label", for: groupName + "-" + item.id }, [
          el("span", { class: "hb-card-swatch", style: "background-image:url(" + item.image + ");", "aria-hidden": "true" }),
          el("span", { class: "hb-card-title", text: item.name })
        ]);
        var viewBtn = el("button", { type: "button", class: "hb-view-btn", text: "View larger" });
        viewBtn.addEventListener("click", function () {
          openLightbox(item.image, item.name, viewBtn);
        });
        wrap.appendChild(input);
        wrap.appendChild(label);
        wrap.appendChild(viewBtn);
        container.appendChild(wrap);
      });
      var groupEl = container.closest(".hb-field-group");
      if (groupEl) groupEl.hidden = items.length === 0;
    }
    buildSwatchGrid(q("#hb-patchcolor-grid"), data.patchColors || [], "hb-patchcolor", function (item) {
      return { "data-materials": (item.materials || []).map(function (m) { return (m || "").trim(); }).join("|").toLowerCase() };
    });
    buildSwatchGrid(q("#hb-patchshape-grid"), data.patchShapes || [], "hb-patchshape");

    // Filter the color grid to only colors available in the selected material.
    // A color with no materials listed is treated as available everywhere.
    function filterPatchColorsByMaterial(materialValue) {
      var grid = q("#hb-patchcolor-grid");
      if (!grid) return;
      var mat = (materialValue || "").trim().toLowerCase();
      grid.querySelectorAll(".hb-swatch-item").forEach(function (wrap) {
        var input = wrap.querySelector("input.hb-card-input");
        var mats = (input.getAttribute("data-materials") || "").split("|").map(function (m) { return m.trim(); }).filter(Boolean);
        var match = !mat || !mats.length || mats.indexOf(mat) !== -1;
        wrap.hidden = !match;
        if (!match && input.checked) {
          input.checked = false;
          state.patchColorId = null;
          state.patchColorName = null;
        }
      });
    }

    // ---- Lightbox ----
    var lightboxTriggerEl = null;
    function openLightbox(imageUrl, name, triggerEl) {
      lightboxTriggerEl = triggerEl || null;
      q("#hb-lightbox-img").src = imageUrl;
      q("#hb-lightbox-img").alt = name;
      q("#hb-lightbox-caption").textContent = name;
      var lb = q("#hb-lightbox");
      lb.hidden = false;
      q("#hb-lightbox-close").focus();
    }
    function closeLightbox() {
      q("#hb-lightbox").hidden = true;
      try {
        if (lightboxTriggerEl && document.contains(lightboxTriggerEl)) {
          lightboxTriggerEl.focus();
        } else {
          q("#hb-main-content").focus();
        }
      } catch (err) { /* ignore focus errors, closing still succeeds */ }
    }
    q("#hb-lightbox-close").addEventListener("click", closeLightbox);
    q("#hb-lightbox").addEventListener("click", function (e) {
      if (e.target === q("#hb-lightbox")) closeLightbox();
    });
    q("#hb-lightbox-img").addEventListener("contextmenu", function (e) { e.preventDefault(); });
    q("#hb-lightbox-img").addEventListener("dragstart", function (e) { e.preventDefault(); });
    document.addEventListener("keydown", function (e) {
      if (!q("#hb-lightbox").hidden) {
        if (e.key === "Escape") closeLightbox();
        else if (e.key === "Tab") { e.preventDefault(); q("#hb-lightbox-close").focus(); }
      }
    });

    // ---- File upload (artwork) ----
    q("#hb-upload-image").addEventListener("change", function (e) {
      var file = e.target.files[0];
      state.uploadedFile = file || null;
      q("#hb-upload-filename").textContent = file ? ("Selected: " + file.name) : "";
      updateStep3NextState();
      updateLiveSummary();
    });

    // ---- Artwork acknowledgment ----
    q("#hb-artwork-ack").addEventListener("change", function (e) {
      state.artworkAcknowledged = e.target.checked;
      updateStep3NextState();
    });

    // ---- Notes ----
    q("#hb-notes").addEventListener("input", function (e) {
      state.notes = e.target.value;
    });

    // ---- Quantity ----
    q("#hb-quantity").addEventListener("input", function (e) {
      var val = parseInt(e.target.value, 10);
      state.quantity = (val && val > 0) ? val : 1;
    });
    q("#hb-qty-minus").addEventListener("click", function () {
      state.quantity = Math.max(1, (state.quantity || 1) - 1);
      q("#hb-quantity").value = state.quantity;
    });
    q("#hb-qty-plus").addEventListener("click", function () {
      state.quantity = (state.quantity || 1) + 1;
      q("#hb-quantity").value = state.quantity;
    });

    function updateStep3NextState() {
      var nextBtn = q("#hb-step3-next");
      if (!nextBtn) return;
      var hasColors = (data.patchColors || []).length > 0;
      var colorOk = !hasColors || !!state.patchColorId;
      if (state.mode === "own") {
        nextBtn.disabled = !(state.uploadedFile && state.artworkAcknowledged && colorOk);
      } else {
        nextBtn.disabled = !(state.galleryDesign && colorOk);
      }
    }

    // ---- Real add to cart ----
    q("#hb-add-to-cart-btn").addEventListener("click", function () {
      if (!state.variantId) {
        announce("Please choose a style and color before adding to cart.");
        return;
      }
      if (state.mode === "own" && (!state.uploadedFile || !state.artworkAcknowledged)) {
        announce("Please upload your artwork and confirm the acknowledgment before adding to cart.");
        return;
      }
      var btn = this;
      btn.disabled = true;
      var statusEl = q("#hb-cart-status");
      statusEl.textContent = "Adding to cart\u2026";

      var formData = new FormData();
      formData.append("id", state.variantId);
      formData.append("quantity", state.quantity || 1);

      if (state.mode === "gallery") {
        var d = data.designs.find(function (g) { return String(g.id) === String(state.galleryDesign); });
        formData.append("properties[Design]", d ? d.name : "Custom");
        if (state.personalization) {
          var propLabel = (d && d.personalizationPrompt) ? d.personalizationPrompt : "Personalization";
          formData.append("properties[" + propLabel + "]", state.personalization);
        }
      } else {
        formData.append("properties[Design]", "Custom \u2014 designed by customer");
        if (state.patchMaterial) formData.append("properties[Patch Material]", state.patchMaterial);
        if (state.patchShapeName) formData.append("properties[Patch Shape]", state.patchShapeName);
        if (state.notes) formData.append("properties[Notes]", state.notes);
        if (state.uploadedFile) formData.append("properties[Custom Design]", state.uploadedFile, state.uploadedFile.name);
      }
      if (state.patchColorName) formData.append("properties[Patch Color]", state.patchColorName);
      formData.append("properties[Placement]", state.placement || "Centered");

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        body: formData
      })
        .then(function (res) { if (!res.ok) return res.json().then(function (e) { throw e; }); return res.json(); })
        .then(function () {
          statusEl.textContent = "Added to cart! You can keep shopping or head to your cart to check out.";
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          btn.disabled = false;
        })
        .catch(function (err) {
          statusEl.textContent = "Sorry, something went wrong adding that to your cart. Please try again.";
          console.error("Hat Builder add-to-cart error:", err);
          btn.disabled = false;
        });
    });

    updateStep3NextState();
    updateLiveSummary();
    updateStepper();
  }
})();